<script>
import { Line } from "vue-chartjs";
export default {
  extends: Line,
  props: ['data'],
  data() {
    return {
      all_months: [  this.$t('statistics.january'), 
                this.$t('statistics.february'), 
                this.$t('statistics.march'), 
                this.$t('statistics.april'), 
                this.$t('statistics.may'), 
                this.$t('statistics.june'), 
                this.$t('statistics.july'), 
                this.$t('statistics.august'), 
                this.$t('statistics.september'), 
                this.$t('statistics.october'), 
                this.$t('statistics.november'), 
                this.$t('statistics.december') ]
    }
  },
  methods: {
    labels(){
      var labels = []
      var today = new Date();
      for(var i = 23; i >= 0; i -= 1) {
        var d = new Date(today.getFullYear(), today.getMonth() - i, 1);
        labels.push((d.getMonth()+1).toString() + "/" + (d.getFullYear()).toString())
      }
      return labels;
    }
  },
  mounted() {
    var dis = this
    this.renderChart(
      {
        labels: this.labels(),
        datasets: [
          {
            data: this.data.count_by_month,
            backgroundColor: "transparent",
            borderColor: "#007bff",
            pointBackgroundColor: "#FFFFFF",
            pointRadius: 3,
            lineTension: 0,           
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        legend: {display: false},
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function(tooltipItem, data) {
                var lab = tooltipItem.xLabel.substr(0, tooltipItem.xLabel.indexOf('/'));
                var xLabel = dis.all_months[parseInt(lab) - 1];
                // Access the "up" count for the month corresponding to the tooltipItem's index
                var upCount = dis.data.count_by_month_up[tooltipItem.index];
                if(tooltipItem.yLabel == 1)
                    var yLabel = tooltipItem.yLabel + dis.$t('statistics.graph_text4');
                else
                    var yLabel = tooltipItem.yLabel + dis.$t('statistics.graph_text5');
                return xLabel + " - " + yLabel + " (+ "+ upCount +")";
              },
              title: function(t, d) {
                return ""
              }
          }
        },
        scales: {
          xAxes: [{
            ticks: {
                fontColor: "#9CA3AF",
            },
            gridLines: {
              display: false,
            }
          }],
          yAxes: [{
            scaleLabel: { color: "#9CA3AF" },
            gridLines: {
              drawBorder: false,
              tickMarkLength: false,
              borderDash: [3, 3],
              color: "#BDBDBD"
            },
            ticks: {
                fontColor: "#9CA3AF",
                beginAtZero: true,
                callback: function(value, index, values) {
                  if(parseInt(value) >= 1000){
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  } else {
                    return value;
                  }
                }
            },
          }],
        }
      }
    );
  }
};
</script>